import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=6406889a&scoped=true"
import script from "./Finances.vue?vue&type=script&lang=js"
export * from "./Finances.vue?vue&type=script&lang=js"
import style0 from "./Finances.vue?vue&type=style&index=0&id=6406889a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406889a",
  null
  
)

export default component.exports